<template>
    <router-link v-if="redirectHome" to="/">
        <img
            src="../assets/logo-buybox.png"
            alt="BUY.BOX"
            class="logo"
            :style="`height: ${height}`"
        >
    </router-link>
    <img
        v-else
        src="../assets/logo-buybox.png"
        alt="BUY.BOX"
        class="logo"
        :style="`height: ${height}`"
    >
</template>

<script>
    export default {
        name: 'AppLogo',
        props: {
            height: {
                type: String,
                default: '35px',
            },
            redirectHome: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .logo {
        width: auto;
    }
</style>
